import { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import { FeatureVariant, GB_FEATURE_KEYS } from '~/services/abTests/features';
import analytics from '~/services/analytics';
import surveyMonkeyService from '~/services/SurveyMonkey';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { ProfileType } from '~/types/profile';

const SurveyManager = (): null => {
  const profile = useAppSelector((state) => state.profile);
  const location = useLocation();
  const config = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.EXTENSION_SURVEYMONKEY_INTEGRATION,
  );

  useEffect(() => {
    if (profile) {
      showSurveyMonkey(profile, location.pathname, config);
    }
  }, [config, profile, location.pathname]);

  return null;
};

function showSurveyMonkey(
  user: ProfileType,
  currentPath: string,
  config: FeatureVariant<GB_FEATURE_KEYS.EXTENSION_SURVEYMONKEY_INTEGRATION>,
): void {
  if (!config) return;

  const {
    show_page,
    days_from_registration,
    total_generations,
    profession,
    survey_id,
  } = config;

  if (show_page !== null && show_page !== '*' && show_page !== currentPath)
    return;

  if (total_generations !== null) {
    const generations = user.user_subscription?.words_generated_total ?? 0;
    if (generations < total_generations) return;
  }

  if (days_from_registration !== null) {
    const createdAt = new Date(user.created_at);
    const now = new Date();
    const msInDay = 1000 * 60 * 60 * 24;
    const passedDays = Math.floor(
      (now.getTime() - createdAt.getTime()) / msInDay,
    );

    if (passedDays < days_from_registration) return;
  }

  if (profession !== null && user.user_onboarding.profession !== profession)
    return;

  surveyMonkeyService.showSurvey({ surveyId: survey_id });
  analytics.trackEvent('survey - modal view', {
    survey_id: survey_id,
    page: show_page,
  });
}

export default SurveyManager;
